import "ulog";
import anylogger from "anylogger";

/**
 * Logger utility
 *
 * allows setting log level based on query param or local storage
 * @see https://github.com/download/ulog for details.
 *
 * This means you can have verbose debugging in development but silence logs in
 * production until you manually change the log level.
 *
 * Default level in development is 'info'
 *
 * Examples:
 *
 * setting with localStorage:
 * localStorage.setItem('log', 'info')
 *
 * setting with query param:
 * debug logs
 * http://unteach.local?log=debug&debug=*
 * Don't forget that chrome filters 'verbose' by default, which is where debug logs go
 *
 * other levels (eg info)
 * http://unteach.local?log=info
 *
 */
const production = process.env.NODE_ENV === "production";

const log = anylogger("app");

// silence logs in production by default
if (production) {
  log.level = log.NONE;
} else {
  log.level = log.INFO;
}

export default log;
